var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 8C14.7647 8 15.3846 8.61832 15.3846 9.38107L15.3846 9.38816C15.3846 10.1509 14.7647 10.7692 14 10.7692C13.2353 10.7692 12.6154 10.1509 12.6154 9.38816L12.6154 9.38107C12.6154 8.61832 13.2353 8 14 8Z",
    fill: "#141B34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 12.6155C14.7647 12.6155 15.3846 13.2338 15.3846 13.9966L15.3846 14.0037C15.3846 14.7664 14.7647 15.3847 14 15.3847C13.2353 15.3847 12.6154 14.7664 12.6154 14.0037L12.6154 13.9966C12.6154 13.2338 13.2353 12.6155 14 12.6155Z",
    fill: "#141B34"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 17.2307C14.7647 17.2307 15.3846 17.8491 15.3846 18.6118L15.3846 18.6189C15.3846 19.3816 14.7647 19.9999 14 19.9999C13.2353 19.9999 12.6154 19.3816 12.6154 18.6189L12.6154 18.6118C12.6154 17.8491 13.2353 17.2307 14 17.2307Z",
    fill: "#141B34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreIcon);
export default __webpack_public_path__ + "static/media/more-icon.c316b1e80b6af460447114c7fccbae8f.svg";
export { ForwardRef as ReactComponent };